import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { LastUpdated } from "../components/LastUpdated";
import { Search, Sparkles, Rss, Clock } from "lucide-react";

const CATEGORIES = ["Semua", "AI", "Robotics", "LLM", "Software"];

export default function Articles() {
  const [params, setParams] = useSearchParams();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState(params.get("search") || "");
  const cat = params.get("category") || "Semua";

  useEffect(() => {
    setLoading(true);
    const qp = new URLSearchParams();
    if (cat && cat !== "Semua") qp.append("category", cat);
    const s = params.get("search");
    if (s) qp.append("search", s);
    api.get(`/articles?${qp.toString()}`).then((r) => {
      setItems(r.data);
      setLoading(false);
    });
  }, [params, cat]);

  const submit = (e) => {
    e.preventDefault();
    const p = new URLSearchParams(params);
    if (q) p.set("search", q); else p.delete("search");
    setParams(p);
  };

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
      <div className="mb-8">
        <div className="chip chip-cyan mb-3"><Rss className="w-3 h-3" /> Newsroom</div>
        <h1 className="font-heading text-4xl md:text-5xl font-black">Berita AI &amp; Robotics</h1>
        <p className="text-slate-400 mt-2 max-w-2xl">Kombinasi kurasi manual, ringkasan AI, dan feed RSS dari sumber terpercaya.</p>
        <LastUpdated className="mt-3" />
      </div>

      <div className="flex flex-col md:flex-row gap-4 mb-8">
        <form onSubmit={submit} className="flex-1 flex items-center bg-card border border-white/10 rounded-full h-12 px-4 focus-within:border-cyan1/50">
          <Search className="w-4 h-4 text-slate-500" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Cari judul, topik, tag..."
            className="bg-transparent flex-1 outline-none px-3 text-sm placeholder:text-slate-600"
            data-testid="articles-search-input"
          />
          <button className="text-cyan1 text-sm font-medium" data-testid="articles-search-submit">Cari</button>
        </form>
        <div className="flex flex-wrap gap-2">
          {CATEGORIES.map((c) => {
            const active = cat === c;
            return (
              <button
                key={c}
                onClick={() => {
                  const p = new URLSearchParams(params);
                  if (c === "Semua") p.delete("category"); else p.set("category", c);
                  setParams(p);
                }}
                className={`px-4 h-12 rounded-full border transition text-sm font-medium ${
                  active
                    ? "border-cyan1 text-void bg-cyan1"
                    : "border-white/10 text-slate-300 hover:border-cyan1/50 hover:text-cyan1"
                }`}
                data-testid={`filter-category-${c}`}
              >
                {c}
              </button>
            );
          })}
        </div>
      </div>

      {loading ? (
        <div className="text-slate-500 text-center py-20">Memuat artikel...</div>
      ) : items.length === 0 ? (
        <div className="text-slate-500 text-center py-20" data-testid="articles-empty">Tidak ada artikel yang cocok.</div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((a) => (
            <Link key={a.id} to={`/articles/${a.slug}`} className="card overflow-hidden flex flex-col group" data-testid={`article-${a.slug}`}>
              {a.image_url && (
                <div className="h-44 overflow-hidden">
                  <img src={a.image_url} alt="" className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                </div>
              )}
              <div className="p-5 flex-1 flex flex-col">
                <div className="flex gap-2 mb-3 flex-wrap">
                  <span className="chip chip-cyan">{a.category}</span>
                  {a.source === "ai" && <span className="chip chip-magenta"><Sparkles className="w-3 h-3" /> AI</span>}
                  {a.source === "rss" && <span className="chip chip-green"><Rss className="w-3 h-3" /> RSS</span>}
                </div>
                <h3 className="font-heading text-lg font-bold leading-snug line-clamp-2">{a.title}</h3>
                <p className="text-sm text-slate-400 mt-2 line-clamp-3 flex-1">{a.excerpt}</p>
                <div className="mt-4 flex items-center gap-3 text-[10px] font-mono uppercase tracking-widest text-slate-500">
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {a.reading_time} min</span>
                  <span>·</span>
                  <span>{new Date(a.published_at).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" })}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
